<!-- 项目文件 -->
<template>
    <div class="w25p floatr disinblock bgfff">
        <div class="baee">
            <div class="pt16 pb16 bgf6">
                <p class="textindent fs16 c000">报名登记</p>
            </div>
            <div class="pl16 pr16 pb16">
                <ul class="pt10 pb5">
                    <li class="mt8 mb8 posre">
                        <span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
                            <i class="w100p textc"><img class="w14 h16" src="../../public/img/img75.png"></i>
                        </span>
                        <input class="w100p baee h40 outline textindent3 fs14 c999" v-model="Name" type="text"
                            placeholder="请输入姓名">
                    </li>
                    <li class="mt8 mb8 posre">
                        <span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
                            <i class="w100p textc"><img class="w12 h16" src="../../public/img/img76.png"></i>
                        </span>
                        <input class="w100p baee h40 outline textindent3 fs14 c999" v-model="Phone" type="text"
                            placeholder="请输入手机号">
                    </li>
                    <li class="mt8 mb8 posre">
                        <span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
                            <i class="w100p textc"><img class="w12 h14" src="../../public/img/img77.png"></i>
                        </span>
                        <input class="w100p baee h40 outline textindent3 fs14 c999" type="text" v-model="Code"
                            placeholder="请输入验证码">
                        <div  class="posab right8 top0 h40 alit"  v-show="show" @click="getCode">
                            <span  class="pt4 pb4 pl10 pr10 bgeaf disinblock    c1f8 fs12 bradius5  cursor">
                                获取验证码
                            </span>
                        </div>
                        <div class="posab right8 top0 h40 alit" v-show="!show">
                            <span  class="pt4 pb4 pl10 pr10 bgeaf disinblock    c1f8 fs12 bradius5  cursor">
                                {{count}} s
                            </span>
                        </div>
                    </li>
                    <li class="mt8 mb8 posre">
                        <span class="w40 disinblock baee h38 bgf6 posab top0 left0 alit">
                            <i class="w100p textc"><img class="w16 h14" src="../../public/img/img78.png"></i>
                        </span>
        
                        <select class="w100p baee h40 outline textindent3 fs14 c999" v-model="Class"
                            @change="changeProduct($event)">
                            <option value="" disabled selected hidden>请选择班型</option>
                            <option v-for="(item,index) in ClassList" :key="index" :value='item' class="pb5 pt5 h50"> {{item}}
                            </option>
                        </select>
                    </li>
        
                    <li class="mt8 mb8 posre">
                        <span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
                            <i class="w100p textc"><img class="w16 h16" src="../../public/img/img79.png"></i>
                        </span>
                        <input class="w100p baee h40 outline textindent3 fs14 c999" type="text" v-model="Address">
                    </li>
        
                </ul>
                <div @click="Submit(Area_id)" class="cf16 fbold cfff bg1f8 textc pt10 pb10 bradius5">提 交</div>
            </div>
        </div>
        <div class="baee mt20">
            <div class="pt16 pb16 bgf6">
                <p class="textindent fs16 c000">口碑排行榜</p>
            </div>
            <div class="pl16 pr16 pb16">
                <ul>
                    <p class="overflow mt20 mb20" v-for="(item,index) in schoolList.slice(0,1)" :key="index">
                        <span class=" disinblock floatl w48p">
                            <i class="bgf351 w20 h20 floatl textc lh20 cfff fs12 br50"> {{index+1}} </i>
                            <span class="bgfff baee  w100  h80 alit floatr">
                                <i class="w100p textc"><img class="w60 h60" :src="item.image"></i>
                            </span>
                        </span>
                        <span class="disinblock floatr w48p">
                            <span class="fs14 c333 disblock"> {{item.school_name}} </span>
                            <span class="alit" v-if="item.star">
                                <img v-if="item.star!=0" v-for="(v,i) in parseInt(item.star)" :key="i" class="w16 h16 mr2"
                                    src="../../public/img/img80_1.png" alt="">
                                <img v-if="parseInt(item.star) != item.star" class="w16 h16 mr2" src="../../public/img/img80_3.png" alt="">
                                <img v-if="item.star < 4.1" v-for="(vv,ii) in 5-Math.ceil(item.star)" class="w16 h16 mr2"
                                    src="../../public/img/img80_2.png" alt="">
                                <i class="cff8 fs15">
                                    {{item.star ||'暂无评分'}}
                                </i>
                            </span>
                            <span class="fs12 c999 over_1 w100p disinblock"> {{item.school_address}} </span>
                        </span>
                    </p>
                    <li class="overflow mt12 mb15 alit posre" v-for="(item,index) in schoolList.slice(1,10)" :key="index+1">
                        <i class="bgf351 w20 h20  textc lh20 cfff fs12 br50 floatl" :class="{'bgb2b':index>1 }"> {{index+2}} </i>
                        <span class="fs14 c333 disblock floatl ml16"> {{item.school_name}} </span>
                        <span class="fs14 c999 disblock floatr posab right0"> {{item.comment_count}} 条评价</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    export default {
        props: ['Area_id'],
        data() {
            return {
                show: true,
                count: '',
                timer: null,
                Name: '',
                Phone: '',
                Code: '',
                Class: '',
                Address: '',
                ClassList: ['C1手动挡', 'C2自动挡'],
                lng: '',
                lat: '',
                schoolList: []
            };
        },
        methods: {
            getCode() { //验证码
                let that = this;
                if (!(/^1[23456789]\d{9}$/.test(that.Phone))) {
                    alert('请正确输入手机号');
                    return 0;
                } else {
                    const TIME_COUNT = 60;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--;
                            } else {
                                this.show = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                    $.ajax({
                        type: "POST",
                        url: that.beseAjax + "/school/sendSmsCode.do",
                        dataType: "json",
                        async: false,
                        data: {
                            "phone": that.Phone,
                            "type": 'login'
                        },
                        success: function(data) {
                            console.log(data)
                        },
                        error: function(data) {
                            console.log(data);
                        }
                    });
                }

            },
            changeProduct(event) {
                this.Class = event.target.value; //获取班型对应的value值
            },
            //高德获取区域
            getLocation() {
                const self = this;
                AMap.plugin("AMap.Geolocation", function() {
                    var geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,
                        timeout: 10000,
                    });
                    geolocation.getCurrentPosition();
                    AMap.event.addListener(geolocation, "complete", onComplete);
                    AMap.event.addListener(geolocation, "error", onError);

                    function onComplete(data) {
                        let province = data.addressComponent.province;
                        let city = data.addressComponent.city;
                        let district = data.addressComponent.district;
                        let street = data.addressComponent.street;
                        self.lng = data.position.lng;
                        self.lat = data.position.lat;
                        self.Address = province + city + district + street;

                        self.getSchool()
                        const {
                            position
                        } = data;
                    }

                    function onError(data) {
                        console.log("定位失败错误：", data);
                        self.getLngLatLocation();
                    }
                });
            },
            getLngLatLocation() {
                AMap.plugin("AMap.CitySearch", function() {
                    var citySearch = new AMap.CitySearch();
                    citySearch.getLocalCity(function(status, result) {
                        console.log(status, JSON.stringify(result));
                        if (status === "complete" && result.info === "OK") {
                            // 查询成功，result即为当前所在城市信息
                            console.log("通过ip获取当前城市：", result);
                            //逆向地理编码
                            AMap.plugin("AMap.Geocoder", function() {
                                var geocoder = new AMap.Geocoder({
                                    // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                                    city: result.adcode,
                                });

                                var lnglat = result.rectangle.split(";")[0].split(",");
                                geocoder.getAddress(lnglat, function(status, data) {
                                    if (status === "complete" && data.info === "OK") {
                                        // result为对应的地理位置详细信息
                                        console.log(data);
                                    }
                                });
                            });
                        }
                    });
                });
            },
            //提交表单
            Submit(Area_id) {
                let that = this;
                if (that.Name == "" || !(/^1[23456789]\d{9}$/.test(that.Phone)) || that.Address == "" || that.Code == "" || that.Class == "") {
                    alert('请正确输入');
                    return 0;
                } else {
                    $.ajax({
                        type: "POST",
                        url: that.beseAjax + '/school/bmdj.do',
                        dataType: "json",
                        async: false,
                        data: {
                            "phone": that.Phone,
                            "name": that.Name,
                            "code": that.Code,
                            "address": that.Address,
                            "class_type": that.Class,
                            "area_id": Area_id,
                            "area_name": "",
                            "school_id": ""
                        },
                        success: function(data) {
                            if (data.code == "0") {
                                alert('提交成功')
                            } else {
                                alert(data.info);
                            }
                        },
                        error: function(data) {
                            alert("网络异常，请稍后重试！");
                        }
                    });
                }
            },
            getSchool() {
                let that = this;
                console.log('高德')
                console.log(that.lng)
                console.log(that.lat)
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + '/school/getSchoolList.do',
                    dataType: "json",
                    async: false,
                    data: {
                        "area_id": that.Area_id,
                        "page": 1,
                        "lng": that.lng,
                        "lat": that.lat,
                        "sort_type": 3
                    },
                    success: function(data) {
                        that.schoolList = data.obj;
                        console.log(data.obj)

                    },
                    error: function(data) {
                        alert("网络异常，请稍后重试！");
                    }
                });
            }
        },
        created() {
            this.getLocation();

        },
        mounted() {

        },
    }
</script>
<style scoped>
    select {
        background: none;
    }
</style>